import createAxiosInstance from "./LambdaApiCierreDia";

export async function fetchFormasPago(paisId, brandId, tokenProd) {
  const axiosInstance = await createAxiosInstance();
  const requestConfig = {
    method: "GET", // Cambia el método si es necesario
    url: `/reclasificacion/available-fields?countryId=${paisId}&brandId=${brandId}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${tokenProd}`,
    },
  };

  return axiosInstance(requestConfig);
}
